import { useKeycloak } from '@react-keycloak/web';

export default function usePermissions(permissions = {}, resource = 'cs-api') {
    const { keycloak } = useKeycloak();
    const roles = keycloak.resourceAccess?.[resource]?.roles || [];
    return Object.keys(permissions).reduce(
        (acc, curr) => ({ ...acc, [curr]: roles.includes(permissions[curr]) }),
        {}
    );
}
